export const KPI_VALUE_TYPE_ABSOLUTE = 'ABSOLUTE';
export const KPI_VALUE_TYPE_RELATIVE = 'RELATIVE';

export const KPI_VALUE_TYPES = [
  KPI_VALUE_TYPE_ABSOLUTE,
  KPI_VALUE_TYPE_RELATIVE
];
